import styled, { css } from 'styled-components';

const shouldForwardProp = (prop) => !['color', 'faded'].includes(prop);

function getNormalBackgroundColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-900)';
    case 'white':
      return 'var(--white)';
    case 'teal':
    case 'pink':
      return `var(--${color}-900)`;
    default:
      return `var(--${color}-600)`;
  }
}

function getNormalHoverBackgroundColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--black)';
    case 'white':
      return 'var(--coolGray-100)';
    case 'teal':
    case 'pink':
      return `var(--${color}-1000)`;
    default:
      return `var(--${color}-700)`;
  }
}

function getFadedBackgroundColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--white)';
    case 'white':
      return 'var(--coolGray-900)';
    case 'blue':
    case 'primary':
      return `var(--${color}-50)`;
    default:
      return `var(--${color}-100)`;
  }
}

function getFadedHoverBackgroundColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-100)';
    case 'white':
      return 'var(--black)';
    case 'blue':
    case 'primary':
      return `var(--${color}-100)`;
    default:
      return `var(--${color}-200)`;
  }
}

function getBackgroundColor(props) {
  return (props.faded ? getFadedBackgroundColor : getNormalBackgroundColor)(props);
}

function getHoverBackgroundColor(props) {
  return (props.faded ? getFadedHoverBackgroundColor : getNormalHoverBackgroundColor)(props);
}

function getNormalColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-200)';
    case 'white':
      return 'var(--coolGray-600)';
    default:
      return getFadedBackgroundColor(props);
  }
}

function getFadedColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-600)';
    case 'white':
      return 'var(--coolGray-200)';
    default:
      return getNormalBackgroundColor(props);
  }
}

function getColor(props) {
  return (props.faded ? getFadedColor : getNormalColor)(props);
}

function getIconColor(props) {
  const { color = 'coolGray' } = props;

  switch (color) {
    case 'black':
    case 'white':
      return 'var(--coolGray-400)';
    case 'blue':
    case 'primary':
      return `var(--${color}-300)`;
    case 'yellow':
      return `var(--${color}-500)`;
    case 'teal':
      return `var(--${color}-600)`;
    default:
      return `var(--${color}-400)`;
  }
}

export const IconWrapper = styled.div`
  line-height: 0;
`;

export const LabelWrapper = styled.div``;

export const Wrapper = styled('div').withConfig({ shouldForwardProp })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  background-color: ${getBackgroundColor};
  border: 0;
  gap: 4px;
  font: inherit;
  font-weight: normal;
  text-align: left;
  line-height: 1.2;
  vertical-align: bottom;
  outline: none;
  transition: all 250ms ease;

  ${(props) =>
    (() => {
      switch (props.size) {
        case 'small':
          return css`
            min-height: 24px;
            gap: 4px;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 14px;
          `;
        case 'regular':
        default:
          return css`
            min-height: 32px;
            gap: 6px;
            padding: 4px 12px;
            border-radius: 16px;
            font-size: 16px;
          `;
      }
    })()}

  ${LabelWrapper} {
    color: ${getColor};
  }

  ${IconWrapper} {
    color: ${getIconColor};
  }

  &:enabled,
  a& {
    cursor: pointer;

    &:hover {
      background-color: ${getHoverBackgroundColor};
    }

    &:hover,
    &:focus {
      text-decoration: none;
    }

    &:focus-visible {
      border-radius: ${(props) =>
        (() => {
          switch (props.size) {
            case 'small':
              return 12;
            case 'regular':
            default:
              return 16;
          }
        })()}px;
      box-shadow: 0 0 0 2px var(--outlineColor);
      text-decoration: none;
    }
  }
`;
